import MeshComponent from './MeshComponent';
export default class FighterComponent extends MeshComponent {
    constructor(game, mesh) {
        super(game, mesh);
        this.angleX = 0;
        this.angleY = 0;
        this.angleZ = 0;
        this.angleVelocity = 0;
        this.rotateMap = {
            ArrowRight: 0.01,
            ArrowLeft: -0.01,
        };
    }
    update() {
        // Rotate and project vertices
        this.angleY += this.angleVelocity;
        this.points = this.mesh.vertices.map((v) => {
            const rotated = this.game.rotate(v, this.angleX, this.angleY, this.angleZ);
            const projected = this.game.toScreen(rotated.add(this.position), true);
            return projected;
        });
    }
    keyPressed(key) {
        if (this.rotateMap[key]) {
            this.angleVelocity = this.rotateMap[key];
        }
    }
    keyReleased(key) {
        if (this.rotateMap[key]) {
            this.angleVelocity = 0;
        }
    }
}
